import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/images/中国移动1.png';
const _hoisted_1 = {
  class: "lives-layout"
};
const _hoisted_2 = {
  class: "question"
};
const _hoisted_3 = {
  class: "answer"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  key: 1,
  class: "loading-dots"
};
const _hoisted_6 = {
  class: "live-decorate"
};
const _hoisted_7 = {
  key: 0,
  class: "live-option"
};
const _hoisted_8 = {
  style: {
    "color": "red"
  }
};
const _hoisted_9 = {
  style: {
    "color": "red"
  }
};
const _hoisted_10 = {
  style: {
    "color": "red"
  }
};
const _hoisted_11 = {
  class: "add-option"
};
const _hoisted_12 = {
  class: "send-container"
};
const _hoisted_13 = {
  class: "send-container"
};
const _hoisted_14 = {
  key: 1,
  class: "live-sub"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1
};
import { onMounted, ref, nextTick, onUnmounted, watch } from "vue";
import marked from 'marked';
import { PollingTimer } from "@/utils/pollingTimer";
import { getLiveRoomStatSession } from '@/request/program';
import { sendLLMAskText } from '@/request/live';
import { useRoute, useRouter } from 'vue-router';
import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';
import { validateWakeWord, getStatusKey, correctKeywords } from './aiLivesTools';
import { debounce } from 'lodash';
import { getToken, getTeamId } from '@/api';
import Recorder from 'recorder-core';
import 'recorder-core/src/engine/pcm';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/index'

import { useAudioPlayer } from '@/hooks/useAudioPlayer.ts';
import heySiri from '@/assets/images/pc唤醒回应.mp3';
const loadingSvg = `
  <path class="path" d="
    M 30 15
    L 28 17
    M 25.61 25.61
    A 15 15, 0, 0, 1, 15 30
    A 15 15, 0, 1, 1, 27.99 7.5
    L 15 15
  " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
`;
const funAsrWsUrl = "wss://ai-api.lzwcdm.com/asr/";
// const funAsrWsUrl = "wss://111.230.50.85:10096/"
const testBitRate = 16; // 位率
const testSampleRate = 16000; // 采样率
const SendFrameSize = 1920; // 发送帧大小
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      isPlaying,
      toggle,
      setVolume,
      pause
    } = useAudioPlayer();
    let wakeWord = ref('');
    let validateWakeWordFn = () => {
      if (validateWakeWord(wakeWord.value)) {
        ElMessage.success('唤醒词验证成功');
      } else {
        ElMessage.error('唤醒词验证失败');
      }
    };
    // 自动播放
    function checkAndPlayVideo() {
      const videoElement = document.getElementById('player-container-id');
      if (videoElement) {
        if (videoElement.paused || videoElement.ended) {
          videoElement.play().catch(error => {
            console.log('自动播放失败:', error);
            // 这里可以添加提示用户手动播放的逻辑
          });
        }
      }
    }
    const route = useRoute();
    const router = useRouter();
    function fetchMarkdownData() {
      return new Promise(resolve => {
        const markdownData = `
# 这是一个标题

这是一些示例文本。

- 列表项 1
- 列表项 2
- 列表项 3

**加粗文本**

[链接](https://example.com)

我不想努力\n碍事的家伙阿萨
    `;
        let currentIndex = 0;
        let result = '';
        const intervalId = setInterval(() => {
          if (currentIndex < markdownData.length) {
            result += markdownData[currentIndex];
            currentIndex++;
          } else {
            clearInterval(intervalId);
            resolve({
              questionId,
              data: result
            });
          }
        }, 100); // 每100毫秒返回一个字符
      });
    }
    // 开房准备
    var player = null;
    let goRoomReserve = () => {
      player = TCPlayer('player-container-id', {
        language: 'zh-CN',
        licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1323112199_1/v_cube.license',
        LicenseKey: '3f94f93c9fb51289e845aa5b5f796dcc',
        autoplay: true
      });
    };
    // 监听房间状态
    let roomUrl = ref(null);
    let liveLoading = ref(false);
    let loadingTextCallback = ref(false);
    let speakStatus = ref('');
    let chatState = ref('');
    let sub = ref('');
    let watchRoomLiveState = async roomId => {
      if (!roomId) return false;
      let res = await getLiveRoomStatSession(roomId);
      let {
        code,
        data
      } = res.data;
      console.log('debug', 'speakStatus状态:', sub.value, data === null || data === void 0 ? void 0 : data.SPEAK_STATUS, data.CHAT_STATE, wakeWordDetected.value);
      if (code !== 200) {
        roomUrl.value = null;
        return false;
      }
      if ([5, 0].includes(data === null || data === void 0 ? void 0 : data.ROOM_STATE)) {
        roomUrl.value = null;
        return false;
      }
      if (roomUrl.value !== (data === null || data === void 0 ? void 0 : data.PLAY_STREAM_ADDR)) {
        roomUrl.value = data === null || data === void 0 ? void 0 : data.PLAY_STREAM_ADDR;
        player.src(data === null || data === void 0 ? void 0 : data.PLAY_STREAM_ADDR);
      }
      // if (roomUrl.value) checkAndPlayVideo(); // 调用方法检查并播放视频
      if (chatState.value !== (data === null || data === void 0 ? void 0 : data.CHAT_STATE)) {
        chatState.value = data === null || data === void 0 ? void 0 : data.CHAT_STATE;
      }
      if (speakStatus.value !== (data === null || data === void 0 ? void 0 : data.SPEAK_STATUS)) {
        speakStatus.value = data === null || data === void 0 ? void 0 : data.SPEAK_STATUS;
        if (!wakeWordDetected.value && (speakStatus.value == "TextOver" || speakStatus.value == "Initial")) {
          speakOver = true;
          if (isRecording.value == false) {
            recStart();
          }
        } else if (!loadingTextCallback.value && (speakStatus.value == "TextStart" || speakStatus.value == "SentenceStart" || chatState.value == 1)) {
          console.log('发送中....');
          streamDescFn();
        }
      }
      return true;
    };
    let pollingTimer = null;
    const updateData = async () => {
      const stopPolling = await watchRoomLiveState(roomId.value);
      // 如果接口错误，则停止轮询
      return !stopPolling;
    };
    let buildImgFormat = () => {
      // 图片默认样式
      let imgList = document.getElementsByTagName("img");
      for (let img of imgList) {
        var _img$style;
        if (((_img$style = img.style) === null || _img$style === void 0 ? void 0 : _img$style.maxWidth) !== "100%") {
          img.style.maxWidth = "100%";
        }
      }
    };
    let scrollInterval = null;
    let scrollDirection = 1; // 1 表示向下滚动，-1 表示向上滚动
    let imgFormatInterval = null;
    let roomId = ref('');
    onMounted(async () => {
      var _route$query, _route$query2;
      // 隐藏指定的标签
      setTimeout(() => {
        const chatbotBubbleButton = document.getElementById('dify-chatbot-bubble-button');
        const viewFooter = document.querySelector('.view-footer');
        if (viewFooter) {
          viewFooter.style.display = 'none';
        }
        if (chatbotBubbleButton) {
          chatbotBubbleButton.style.display = 'none';
        }
      }, 300); // 延迟1秒
      if (!((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.roomId)) return;
      roomId.value = (_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.roomId;
      // 打开房间
      await goRoomReserve();
      //  进入房间 监听房间状态
      pollingTimer = new PollingTimer(updateData, 1000);
      pollingTimer.start();
      const liveReplyElement = document.querySelector('.live-reply');
      if (liveReplyElement) {
        const startScrolling = () => {
          scrollInterval = setInterval(() => {
            liveReplyElement.scrollTop += scrollDirection;
          }, 10); // 调整滚动速度
        };
        startScrolling();
        // 鼠标悬停时暂停滚动
        liveReplyElement.addEventListener('mouseenter', () => clearInterval(scrollInterval));
        liveReplyElement.addEventListener('mouseleave', startScrolling);
      }
      imgFormatInterval = setInterval(() => {
        buildImgFormat();
      }, 1000); // 每5秒调用一次
    });
    let questionArr = ref([]);
    // 在内容更新后调用此函数
    function scrollToBottom() {
      const liveReplyElement = document.querySelector('.live-reply');
      if (liveReplyElement) {
        setTimeout(() => {
          liveReplyElement.scrollTop = liveReplyElement.scrollHeight;
        }, 0); // 使用 setTimeout 确保 DOM 完全更新后再滚动
      }
    }
    // 自动滚动 live-reply 内容
    watch(() => questionArr.value, (newVal, oldVal) => {
      nextTick(() => {
        scrollToBottom(); // 在 DOM 更新后滚动到底部
      });
    }, {
      deep: true
    });
    // 定时更新最新问题的答案
    function formatLatestQuestionAnswer() {
      if (questionArr.value.length > 0) {
        const latestQuestion = questionArr.value[questionArr.value.length - 1];
        if (latestQuestion.data) {
          latestQuestion.answer = marked(latestQuestion.data);
        }
      }
    }
    // let formatInterval = setInterval(formatLatestQuestionAnswer, 1000);
    onUnmounted(() => {
      pollingTimer.cancel();
      clearInterval(scrollInterval); // 清除定时器
      clearInterval(imgFormatInterval);
      // clearInterval(formatInterval);
      stopTimer();
      if (player) {
        player.pause(); // 暂停视频播放
        player.dispose(); // 释放播放器资源
      }
    });
    async function fetchQuestion() {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({
            id: Date.now(),
            text: "这是一个问题"
          }); // 返回一个带有唯一ID的问题对象
        }, 500); // 模拟网络延迟
      });
    }
    let creating = false;
    async function streamDescFn() {
      creating = true;
      loadingTextCallback.value = true;
      try {
        const response = await fetch(`/api/app/liveRoom/text/callback/${roomId.value}`, {
          method: 'GET',
          timeout: 50000,
          headers: {
            'Authorization': getToken(),
            'App-Team-Id': getTeamId()
          }
        });
        if (!response.body) {
          throw new Error('Response body is null');
        }
        const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
        let buffer = '';
        while (creating) {
          const {
            value,
            done
          } = await reader.read();
          if (done) break;
          buffer += value;
          const lines = buffer.split('\n');
          buffer = lines.pop() || '';
          for (const line of lines) {
            if (line.trim()) {
              try {
                const cleanedLine = line.replace(/^data:\s*/, '').replace(/\\n/g, '\n');
                console.log('Received:', cleanedLine);
                updateAnswerForQuestion(cleanedLine);
              } catch (error) {
                console.error('Error parsing line:', error);
              }
            }
          }
        }
      } catch (error) {
        console.error('Error in streamDescFn:', error);
      } finally {
        loadingTextCallback.value = false;
        creating = false;
        // words = '';
      }
    }
    let questionTime = null;
    let isQuestionAdded = ref(false); // 添加一个标志来跟踪问题是否已添加
    async function addItemToQuestionArr(question) {
      try {
        questionTime = question.id;
        questionArr.value.push({
          id: question.id,
          question: question.text,
          answer: null,
          data: ''
        });
        isQuestionAdded.value = true; // 设置标志为 true，表示问题已添加
        nextTick(() => {
          checkAndPlayVideo();
        });
      } catch (error) {
        console.error("Error fetching question:", error);
      }
    }
    // 更新问题的答案
    async function updateAnswerForQuestion(currentResult) {
      const questionItem = questionArr.value.find(item => item.id === questionTime);
      if (questionItem) {
        questionItem.data += currentResult;
        questionItem.answer = marked(questionItem.data); // 直接更新答案
      }
    }
    const funAsrParams = {
      mode: "2pass",
      chunk_size: [0, 10, 5],
      chunk_interval: 10,
      itn: false,
      is_speaking: true,
      wav_name: "h5",
      hot_words: "阿里巴巴 20\n达摩院 20\n夜雨飘零 20\n"
    };
    const funAsrInitMsg = JSON.stringify(funAsrParams);
    let rec = null; // 录制对象
    let pcmFrame = new Int16Array(SendFrameSize);
    const isRecording = ref(false); // 是否正在录制
    let realTimeSendTryNumber = 0; // 实时发送尝试次数
    let realTimeSendTryChunk = null; // 实时发送尝试块
    let realTimeSendTryChunks = null; // 实时发送尝试块
    const transferUploadNumberMax = ref(0); // 传输上传次数
    let lastTextTime = 0;
    let words = '';
    let timer = null; // 定时器
    let speakOver = true;
    // 创建一个WebSocket连接
    const ws = new WebSocket(funAsrWsUrl);
    ws.onopen = openEvent => {
      console.log('socket连接:', openEvent);
      ws.send(funAsrInitMsg);
      console.log('发送启动参数:', funAsrInitMsg);
    };
    ws.onmessage = jsonMsg => {
      console.log('jsonMsg', jsonMsg);
      const data = JSON.parse(jsonMsg.data);
      const {
        is_final,
        text,
        timestamp
      } = data;
      const len = text.length;
      if (timestamp && len > 0) {
        const wordsLen = words.length;
        lastTextTime = new Date().getTime();
        words += text;
        console.log('debug', "message1", text, words);
        checkWakeup(words);
        console.log('debug', "message2", text, words);
      }
    };
    ws.onclose = closeEvent => {
      console.log('socket关闭:', closeEvent);
      recStop();
    };
    ws.onerror = errEvent => {
      console.log('socket报错:', errEvent);
    };
    const micStarted = ref(false);
    let wakeupWords = '';
    const wakeWordDetected = ref(false); // 标志位，表示是否检测到唤醒词
    watch(() => wakeWordDetected.value, (newVal, oldVal) => {
      toggleMute(newVal);
      if (newVal == false) {
        if (isRecording.value == false) {
          // 当未检测到唤醒词，且麦克风未开启
          recStart();
        }
      } else {
        ElMessage.success("我已经准备好了，随时为您解答问题~");
      }
    }, {
      deep: true
    });
    // 开始录音
    function recStart() {
      isRecording.value = true;
      if (rec) {
        rec.close();
      }
      Recorder.CLog = function () {};
      rec = Recorder({
        type: 'pcm',
        sampleRate: testSampleRate,
        bitRate: testBitRate,
        onProcess: function (buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) {
          //录音实时回调，大约1秒调用12次本回调，buffers为开始到现在的所有录音pcm数据块(16位小端LE)
          //可利用extensions/sonic.js插件实时变速变调，此插件计算量巨大，onProcess需要返回true开启异步模式
          //可实时上传（发送）数据，配合Recorder.SampleData方法，将buffers中的新数据连续的转换成pcm上传，或使用mock方法将新数据连续的转码成其他格式上传，可以参考文档里面的：Demo片段列表 -> 实时转码并上传-通用版；基于本功能可以做到：实时转发数据、实时保存数据、实时语音识别（ASR）等
          //推入实时处理，因为是unknown格式，buffers和rec.buffers是完全相同的，只需清理buffers就能释放内存。
          realTimeSendTry(buffers, bufferSampleRate, false);
        }
      });
      rec.open(() => {
        console.log('开始录音');
        try {
          rec.start(); // 开始录音
          realTimeSendTryReset(); // 重置环境，开始录音时必须调用一次
          console.log('debug', "开始录音message add", words);
          // 启动vad，两秒无词
          startVadTimer();
        } catch (error) {
          console.log(error);
        }
      }, (msg, isUserNotAllow) => {
        console.log((isUserNotAllow ? 'UserNotAllow，' : '') + '无法录音:' + msg);
        isRecording.value = false; // 设置为false
        // console.error('录音异常:', msg); // 提示异常
      });
    }
    // 停止录音
    function recStop() {
      console.log('recStop stop0');
      if (rec) {
        console.log('recStop stop1');
        rec.stop(function (blob, duration) {
          console.log('recStop stop2');
          //简单利用URL生成本地文件地址，注意不用了时需要revokeObjectURL，否则霸占内存
          //此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
          // audioUrl.value = (window.URL || webkitURL).createObjectURL(blob);
          rec.close(); //释放录音资源，当然可以不释放，后面可以连续调用start；但不释放时系统或浏览器会一直提示在录音，最佳操作是录完就close掉
          realTimeSendTry([], 0, true); // 最后一次发送
          rec = null;
          isRecording.value = false;
          realTimeSendTryReset();
        }, function (msg) {
          console.log('录音失败:' + msg);
          rec.close(); //可以通过stop方法的第3个参数来自动调用close
          // handleSendAudio(null, 1, true);
          rec = null;
          realTimeSendTryReset();
        });
        // rec.close(); // 直接close掉即可，这个例子不需要获得最终的音频文件
      }
      isRecording.value = false;
      realTimeSendTryReset();
    }
    // 实时处理核心函数
    function realTimeSendTry(buffers, bufferSampleRate, isClose) {
      if (realTimeSendTryChunks == null) {
        realTimeSendTryNumber = 0;
        transferUploadNumberMax.value = 0;
        realTimeSendTryChunk = null;
        realTimeSendTryChunks = [];
      }
      let pcm = [],
        pcmSampleRate = 0;
      if (buffers.length > 0) {
        isRecording.value = true;
        //借用SampleData函数进行数据的连续处理，采样率转换是顺带的，得到新的pcm数据
        let chunk = Recorder.SampleData(buffers, bufferSampleRate, testSampleRate, realTimeSendTryChunk);
        //清理已处理完的缓冲数据，释放内存以支持长时间录音，最后完成录音时不能调用stop，因为数据已经被清掉了
        for (let i = realTimeSendTryChunk ? realTimeSendTryChunk.index : 0; i < chunk.index; i++) {
          buffers[i] = null;
        }
        realTimeSendTryChunk = chunk; //此时的chunk.data就是原始的音频16位pcm数据（小端LE），直接保存即为16位pcm文件、加个wav头即为wav文件、丢给mp3编码器转一下码即为mp3文件
        // console.log('chunk', chunk)
        pcm = chunk.data;
        pcmSampleRate = chunk.sampleRate;
        if (pcmSampleRate !== testSampleRate)
          //除非是onProcess给的bufferSampleRate低于testSampleRate
          throw new Error('不应该出现pcm采样率' + pcmSampleRate + '和需要的采样率' + testSampleRate + '不一致');
      }
      //将pcm数据丢进缓冲，凑够一帧发送，缓冲内的数据可能有多帧，循环切分发送
      if (pcm.length > 0) {
        // console.log('放入缓冲区', pcm.length)
        realTimeSendTryChunks.push({
          pcm: pcm,
          pcmSampleRate: pcmSampleRate
        });
      }
      //从缓冲中切出一帧数据
      let chunkSize = SendFrameSize / (testBitRate / 8);
      let pcmFrame = new Int16Array(chunkSize);
      pcmSampleRate = 0;
      let pcmOK = false,
        pcmIndex = 0;
      for (let i1 = 0; i1 < realTimeSendTryChunks.length; i1++) {
        let cacheChunk = realTimeSendTryChunks[i1];
        pcmSampleRate = cacheChunk.pcmSampleRate;
        for (let i2 = cacheChunk.offset || 0; i2 < cacheChunk.pcm.length; i2++) {
          pcmFrame[pcmIndex] = cacheChunk.pcm[i2];
          pcmIndex++;
          //满一帧了，清除已消费掉的缓冲
          if (pcmIndex == chunkSize) {
            // console.log('满一帧', pcmIndex)
            pcmOK = true;
            cacheChunk.offset = i2 + 1;
            for (let i3 = 0; i3 < i1; i3++) {
              realTimeSendTryChunks.splice(0, 1);
            }
            break;
          }
        }
      }
      //缓冲的数据不够一帧时，不发送 或者 是结束了
      if (!pcmOK) {
        if (isClose) {
          let number = ++realTimeSendTryNumber;
          transferUpload(number, null, 0, null, isClose);
        }
        return;
      }
      //16位pcm格式可以不经过mock转码，直接发送new Blob([pcm.buffer],{type:"audio/pcm"}) 但8位的就必须转码，通用起见，均转码处理，pcm转码速度极快
      let number = ++realTimeSendTryNumber;
      let encStartTime = Date.now();
      let recMock = Recorder({
        type: 'pcm',
        sampleRate: testSampleRate,
        bitRate: testBitRate //需要转换成的比特率
      });
      recMock.mock(pcmFrame, pcmSampleRate);
      recMock.stop(function (blob, duration) {
        blob.encTime = Date.now() - encStartTime;
        //转码好就推入传输
        transferUpload(number, blob, duration, recMock, false);
        //循环调用，继续切分缓冲中的数据帧，直到不够一帧
        realTimeSendTry([], 0, isClose);
      }, function (msg) {
        //转码错误？没想到什么时候会产生错误！
        console.log('不应该出现的错误:' + msg, 1);
      });
    }
    // 上传数据
    function transferUpload(number, blobOrNull, duration, blobRec, isClose) {
      if (blobOrNull) ws.send(blobOrNull);
    }
    // 重置实时处理
    function realTimeSendTryReset() {
      realTimeSendTryChunks = null;
      stopTimer();
    }
    // 开始定时器
    const startVadTimer = () => {
      console.log('wordswordswordswords', words);
      timer = setInterval(() => {
        var _words;
        const current = new Date().getTime();
        const span = current - lastTextTime;
        console.log('timer start', wakeWordDetected, words, words.length);
        if (wakeWordDetected.value && span > 2500 && ((_words = words) === null || _words === void 0 ? void 0 : _words.length) > 2) {
          console.log('debug', 'sendLLMAskTextFn', wakeWordDetected, words);
          recStop();
          // words = words.replace(wakeupWords, '');
          sendLLMAskTextFn(words);
          wakeWordDetected.value = false;
        }
      }, 300);
    };
    const stopTimer = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };
    // 检查唤醒词
    const wakeupWordsArray = [['小'], ['和', '河', '何'], ['小', '晓'], ['和', '河', '何']];
    const getWakeupWords = content => {
      let iRound = 0,
        i = 0;
      for (let t of content) {
        console.log('debug', 'getWakeupWords', iRound, t);
        if (iRound >= wakeupWordsArray.length) {
          return content.substring(0, i + 1);
        }
        const round = wakeupWordsArray[iRound];
        if (round.indexOf(t) > -1) {
          iRound++;
          console.log('debug', '命中', iRound, t);
          if (iRound >= wakeupWordsArray.length) {
            return content.substring(0, i + 1);
          }
        }
        i++;
      }
      return null;
    };
    const checkWakeup = debounce(content => {
      // console.log('debug', 'checkWakeup', content);
      if (content.length >= 4 && !wakeWordDetected.value) {
        const _wakeupWords = getWakeupWords(content);
        console.log('debug', 'checkWakeup', _wakeupWords);
        if (_wakeupWords != null) {
          wakeWordDetected.value = true; // 设置标志位，表示已经检测到唤醒词
          wakeupWords = _wakeupWords;
          words = words.replace(_wakeupWords, '');
          if (words.startsWith('，')) {
            words.replace("，", '');
          }
        } else {
          console.log('debug', '清空words');
          words = '';
        }
      }
    });
    // 发送问题
    let sendLLMAskTextFn = debounce(content => {
      let optimizeContent = correctKeywords(content);
      let params = {
        "roomId": roomId.value,
        "text": optimizeContent,
        "interrupt": true
      };
      sendLLMAskText(params).then(res => {
        const {
          code,
          data,
          msg
        } = res.data;
        if (code === 200) {
          addItemToQuestionArr({
            id: Date.now(),
            text: optimizeContent
          });
          words = '';
        }
      }).finally(() => {
        // 不静音
        wakeWordDetected.value = false;
      });
    }, 200);
    // 打断说话
    let sendTnterruptFn = content => {
      return sendLLMAskText({
        "roomId": roomId.value,
        "text": '',
        "interrupt": true
      });
    };
    // 开关视频音量
    const toggleMute = muteSwitch => {
      const videoElement = document.getElementById('player-container-id_html5_api');
      if (videoElement) {
        videoElement.muted = muteSwitch !== null ? muteSwitch : !videoElement.muted; // 使用传入的值或切换静音状态
      }
      if (muteSwitch) {
        // 每次唤醒时播放 heySiri 音频
        callHeySiri();
      }
    };
    let callHeySiri = () => {
      pause();
      isPlaying.value = false;
      toggle(heySiri);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_row = _resolveComponent("el-row");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        class: "layout-main",
        style: {
          "flex": "1"
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", {
          class: "live-main",
          spinner: 'loading-spinner',
          "element-loading-svg": loadingSvg,
          "element-loading-text": "直播间加载中...",
          "element-loading-background": "rgba(0,0,0,0)",
          "element-loading-svg-view-box": "-10, -10, 50, 50"
        }, [_cache[12] || (_cache[12] = _createElementVNode("video", {
          id: "player-container-id",
          style: {
            "width": "100%",
            "height": "100%"
          },
          eload: "auto",
          playsinline: "",
          "webkit-playsinline": "",
          autoplay: ""
        }, null, -1)), _createElementVNode("div", {
          class: "live-reply my-scroller",
          spinner: 'loading-spinner',
          "element-loading-svg": loadingSvg,
          "element-loading-text": "请稍候，正在加载内容....",
          "element-loading-background": "rgba(63, 63, 64, 0.5)",
          "element-loading-svg-view-box": "-10, -10, 50, 50"
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(questionArr), i => {
          return _openBlock(), _createElementBlock("div", {
            key: i,
            class: "live-reply-item"
          }, [_createElementVNode("div", _hoisted_2, "问题：" + _toDisplayString(i.question), 1), _createElementVNode("div", _hoisted_3, [_cache[5] || (_cache[5] = _createTextVNode(" 解答： ")), i.answer ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            innerHTML: i.answer
          }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("span", _hoisted_5, "...."))])]);
        }), 128))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, [_cache[6] || (_cache[6] = _createTextVNode("LIVE ")), _createElementVNode("i", {
          class: _normalizeClass(["ri-live-fill", _unref(getStatusKey)(_unref(speakStatus))]),
          style: {
            "margin-left": "5px"
          }
        }, null, 2)])]), _cache[13] || (_cache[13] = _createElementVNode("div", {
          class: "live-prompt"
        }, [_createElementVNode("i", {
          class: "ri-information-fill"
        }), _createTextVNode(" 温馨提示：说出“"), _createElementVNode("span", {
          class: "highlight"
        }, "小和小和"), _createTextVNode("，"), _createElementVNode("span", {
          class: "highlight",
          style: {
            "color": "#ff8c00"
          }
        }, "[您感兴趣的内容]"), _createTextVNode("”。我们的智能聊天助手将竭诚为您提供详尽的解答。 ")], -1)), false ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[10] || (_cache[10] = _createElementVNode("h3", null, "发送指令面板", -1)), _cache[11] || (_cache[11] = _createElementVNode("p", null, "注意:仅仅只是临时使用,发到生产会自行隐藏", -1)), _createElementVNode("p", null, [_cache[7] || (_cache[7] = _createTextVNode("speakStatus状态: ")), _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(speakStatus)), 1)]), _createElementVNode("p", null, [_cache[8] || (_cache[8] = _createTextVNode("chatState状态: ")), _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(chatState)), 1)]), _createElementVNode("p", null, [_cache[9] || (_cache[9] = _createTextVNode("打断状态: ")), _createElementVNode("span", _hoisted_10, _toDisplayString(wakeWordDetected.value), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
          class: "interrupt",
          onClick: _cache[0] || (_cache[0] =
          //@ts-ignore
          (...args) => _unref(sendTnterruptFn) && _unref(sendTnterruptFn)(...args))
        }, "打断说话"), _createElementVNode("div", {
          class: "interrupt",
          onClick: toggleMute
        }, "静音开关")]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, [_createVNode(_component_el_input, {
          modelValue: _unref(sub),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(sub) ? sub.value = $event : sub = $event),
          placeholder: "随时欢迎提问，我在这里等您~"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", {
          class: "send-button",
          style: {
            "color": "red",
            "margin-left": "10px"
          },
          onClick: _cache[2] || (_cache[2] = $event => (_isRef(words) //@ts-ignore
          ? words.value = _unref(sub) : words = _unref(sub), _ctx.checkWakeWords(_unref(sub))))
        }, " 发送问题 ")]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_createVNode(_component_el_input, {
          modelValue: _unref(wakeWord),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(wakeWord) ? wakeWord.value = $event : wakeWord = $event),
          placeholder: "提问语句纠正,可校验"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", {
          class: "send-button",
          style: {
            "color": "red",
            "margin-left": "10px"
          },
          onClick: _cache[4] || (_cache[4] = $event => _unref(correctKeywords)(_unref(wakeWord)))
        }, " 提问语句纠正 ")])])) : _createCommentVNode("", true), _cache[14] || (_cache[14] = _createElementVNode("div", {
          class: "live-logo"
        }, [_createElementVNode("img", {
          src: _imports_0
        })], -1)), false ? (_openBlock(), _createElementBlock("div", _hoisted_14, [['TextOver', 'Initial'].includes(_unref(speakStatus)) ? (_openBlock(), _createElementBlock("span", _hoisted_15, "随时欢迎提问，我在这里等您~")) : (_openBlock(), _createElementBlock("span", _hoisted_16, [_createElementVNode("span", null, _toDisplayString(_unref(sub)), 1)]))])) : _createCommentVNode("", true)])), [[_directive_loading, _unref(liveLoading)]])]),
        _: 1
      })]);
    };
  }
});